import logging from "utils/logging";

/**
 * Console analytics adapter. Logs all analytics operations via utils/logging
 * (which uses loglevel). Used in local/dev environments where we don't want
 * to pollute staging/prod PostHog projects.
 *
 * Conforms to AnalyticsAdapter (see src/analytics/contract.js).
 */

const log = logging.getLogger("analytics");

let identifiedUser = null;
let optedOut = false;

const consoleAdapter = {
  name: "console",

  init: async (apiKey, opts = {}) => {
    log.debug("init", { apiKey: apiKey ? "<set>" : "<empty>", opts });
  },

  identify: (userId, traits = {}) => {
    if (optedOut) return;
    identifiedUser = userId;
    log.debug("identify", { userId, traits });
  },

  alias: (previousId, newId) => {
    if (optedOut) return;
    log.debug("alias", { previousId, newId });
  },

  track: (eventName, props = {}) => {
    if (optedOut) return;
    log.debug(`track ${eventName}`, { props, userId: identifiedUser });
  },

  page: (path, props = {}) => {
    if (optedOut) return;
    log.debug(`page ${path}`, props);
  },

  captureError: (error, ctx = {}) => {
    if (optedOut) return;
    // Use console.error directly — log.error() would re-enter captureError (infinite loop)
    console.error("[Analytics] captureError", {
      message: error?.message,
      name: error?.name,
      stack: error?.stack,
      ctx,
    });
  },

  reset: () => {
    identifiedUser = null;
    log.debug("reset");
  },

  setOptOut: (value) => {
    optedOut = Boolean(value);
    log.debug("setOptOut", { optedOut });
  },
};

export default consoleAdapter;
